(function () {
  'use strict';

  angular.module('ringbaPortal').component('panelCollapse', {
    bindings: {
      showPanel: '=',
      panelName: '@',
      onExpand: '&',
      sticky: '<'
    },
    controller: PanelCollapseController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/panel-collapse/panel-collapse.view.html'
  });

  function PanelCollapseController(
    userSettingsService
  ) {
    'ngInject';

    const vm = this;
    vm.$onInit = onInit;
    vm.onClickCollapse = onClickCollapse;

    function onInit() {
      vm.sticky = vm.sticky !== undefined ? vm.sticky : true;
      if (vm.sticky) {
        userSettingsService.getUserSettings().then(function (userSettings) {
          vm.showPanel = (userSettings.panelsState && userSettings.panelsState[vm.panelName] !== undefined) ? userSettings.panelsState[vm.panelName] : true;
        });
      } else {
        vm.showPanel = true;
      }
    }

    function onClickCollapse() {
      vm.showPanel = !vm.showPanel;
      if (vm.showPanel) {
        vm.onExpand();
      }

      if (!vm.sticky) {
        return;
      }
      userSettingsService.getUserSettings().then(function (userSettings) {
        userSettings.panelsState = userSettings.panelsState || {};
        userSettings.panelsState[vm.panelName] = vm.showPanel;
        userSettingsService.saveUserSettings(userSettings);
      });
    }

  }
})();
